<cap-rubrik [isClosable]="false" [isOpen]="true" class="externe-daten">
  <ng-container title>
    <h2 class="mb-0">{{ "neskoab.Nutzniessung" | translate }}</h2>
  </ng-container>

  <cap-list-loader [defaultText]="'gemaessAmtlicherBewertung'" [hasRight]="hasRight" [listLoader]="listLoader" [showTotal]="false">
    <div class="cap-list-loader-title">
      <ng-content select="[name=title]"></ng-content>
    </div>
    <div class="cap-list-loader-content">
      <table class="cap-table-detail">
        <thead>
          <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
        </thead>
        <tbody>
          <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
        </tbody>
      </table>
    </div>
  </cap-list-loader>
</cap-rubrik>

<ng-template #tableHeaders>
  <tr>
    <th>{{ "neskoab.Nutzniesser" | translate }}</th>
    <th>{{ "KantonalePersonenID" | translate }}</th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item; let odd = $odd) {
    <tr [ngClass]="{ even: !odd, odd: odd }" class="invisibleRow">
      <td>
        @if (item.zentralePerson) {
          <span>
            {{ item.object.gesamthandVerhaeltnis }} {{ item.zentralePerson.bezeichnung }}
            <div>
              @if (item.zentralePerson?.adressen[0]) {
                <cap-kompakt-personenadresse
                  [entry]="item.zentralePerson"
                  [item]="item.zentralePerson?.adressen[0]"></cap-kompakt-personenadresse>
              }
            </div>
          </span>
        }
        {{ item.object.eigentumForm }}
      </td>
      <td>
        @if (item.zentralePerson?.fremdId) {
          <cap-link
            [params]="[item.zentralePerson?.fremdId]"
            [target]="navTargets.NAV_PERSON_ZPV"
            [tooltipParams]="{ person: item.zentralePerson.bezeichnung }">
            <span>
              {{ item.zentralePerson.fremdId }}
            </span>
          </cap-link>
        }
      </td>
    </tr>
  }
</ng-template>
